import React, { useEffect, useRef, memo } from "react";

const darkMode = localStorage.getItem("darkMode") === "true";

function TradingViewTickers () {
    const container = useRef();
    useEffect(
        () => {
            const script = document.createElement("script");
            script.src = "https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js";
            script.type = "text/javascript";
            script.async = true;
            script.innerHTML = `
            {
                "symbols": [
                    {
                      "title": "BTC/USD",
                      "proName": "COINBASE:BTCUSD"
                    },
                    {
                      "title": "ETH/USD",
                      "proName": "COINBASE:ETHUSD"
                    },
                    {
                      "title": "BNB/USD",
                      "proName": "COINBASE:BNBUSD"
                    },
                    {
                      "title": "SOL/USD",
                      "proName": "COINBASE:SOLUSD"
                    },
                    {
                      "title": "HYPE/USD",
                      "proName": "COINBASE:HYPEUSD"
                    },
                    {
                      "title": "ETH/BTC",
                      "proName": "BINANCE:ETHBTC"
                    },
                    {
                      "title": "BNB/BTC",
                      "proName": "BINANCE:BNBBTC"
                    },
                    {
                      "title": "NQ100",
                      "proName": "OANDA:NAS100USD"
                    },
                   {
                      "title": "SP500",
                      "proName": "OANDA:SPX500USD"
                    },
                    {
                      "title": "XAU/USDT",
                      "proName": "BINANCE:XAUUSDT.P"
                    },
                    {
                      "title": "CL/USDT",
                      "proName": "BINANCE:CLUSDT.P"
                    },
                    {
                      "title": "USD/CNH",
                      "proName": "OANDA:USDCNH"
                    }],
                "showSymbolLogo": true,
                "isTransparent": true,
                "displayMode": "regular",
                "colorTheme": "${darkMode ? "dark" : "light"}",
                "locale": "en"
            }`;
            container.current.appendChild(script);
        }, []
    );

    // displayMode: adaptive/regular/compact
    return (<div className="tradingview-widget-container" ref={container}/>);
}

export default memo(TradingViewTickers);


// WEBPACK FOOTER //
// ./src/component/TradingViewTickers.jsx